import { PropsWithChildren } from "react"
import { classNames } from "../../style/common"

export type ContentContainerProps = PropsWithChildren & {
    header?: string,
    subHeader?: string,
    className?: string | undefined,
    classNames?: {
        container?: string | undefined,
        childrenContainer?: string | undefined
    }
}

export function ContentContainer(props: ContentContainerProps) {
    return (
        <div
            className={
                classNames(
                    `px-4 md:px-8 pt-8 pb-24`,
                    props.className,
                    props.classNames?.container
                )
            }
        >
            {
                props.header &&
                <h1 className="text-3xl font-bold tracking-tight">
                    {props.header}
                </h1>
            }
            {
                props.subHeader &&
                <span className="block text-contrast-tertiary leading-5 whitespace-pre-wrap">{props.subHeader}</span>
            }
            <div className={classNames("mt-8", props.classNames?.childrenContainer)}>
                {
                    props.children
                }
            </div>
        </div>
    )
}